import { useState } from 'react';
import Chip from '@/component/Chip/Chip';
import Translate from '@/component/Translate';
import { useTexts } from '../lang';
import { FeatureToggleDialog } from './index';
import useFeatures from './useFeatures';

interface FeaturesActiveChipProps {
  vertical?: boolean;
}

const FeaturesActiveChip = ({ vertical = false }: FeaturesActiveChipProps) => {
  const [open, setOpen] = useState(false);
  const texts = useTexts();
  const features = useFeatures();

  return (
    <>
      {features.activeCount > 0 && (
        <Chip
          label={<Translate text={texts.app.features.activeNotice} />}
          tooltip="Beta features activated"
          vertical={vertical}
          onClick={() => setOpen(true)}
          clickable
          sx={{
            ...(vertical && { minWidth: 50 }),
          }}
        />
      )}
      <FeatureToggleDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default FeaturesActiveChip;
